<div
  class="mfa-action-verification-modal-wrapper"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="currentStep === 'RESULT' ? 'mfa-action-result-heading' : 'mfa-action-heading'"
  [attr.aria-describedby]="currentStep === 'RESULT' ? 'mfa-action-result-description' : 'mfa-action-description'">
  <button
    type="button"
    class="close-button-wrapper"
    (click)="close()"
    [disabled]="loading"
    [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>

  @if (currentStep !== 'RESULT') {
    <h2 id="mfa-action-heading" class="header" [innerHTML]="actionConfig?.introTitleKey | translate"></h2>
  }
  @if (currentStep === 'RESULT') {
    <h2 id="mfa-action-result-heading" class="header" [innerHTML]="resultTitleKey | translate"></h2>
  }
  @if (currentStep === 'CODE') {
    <div class="content">
      @if (!loading) {
        <p
          id="mfa-action-description"
          class="text text--step-description"
          [innerHTML]="actionConfig?.codeStepDescriptionKey | translate: { phoneNumber: data.phoneNumber }"></p>
      }
      @if (!loading) {
        <div class="code-panel">
          <form [formGroup]="codeForm" class="form" autocomplete="off">
            <nz-form-item>
              <nz-form-label nzFor="mfa-action-code" nzRequired>
                {{ 'MFA_ACTION_VERIFICATION_MODAL.CODE_STEP.CODE_LABEL' | translate }}
              </nz-form-label>
              <nz-form-control>
                <nz-input-group class="mfa-input-group">
                  <input
                    nz-input
                    id="mfa-action-code"
                    type="text"
                    inputmode="numeric"
                    maxlength="6"
                    formControlName="code"
                    autocomplete="one-time-code"
                    autocapitalize="off"
                    autocorrect="off"
                    spellcheck="false"
                    data-lpignore="true"
                    data-form-type="other"
                    data-1p-ignore="true"
                    [attr.aria-invalid]="codeForm.controls.code.invalid && codeForm.controls.code.touched"
                    [attr.aria-describedby]="
                      codeForm.controls.code.invalid && codeForm.controls.code.touched
                        ? 'mfa-action-code-error'
                        : codeErrorMessageKey
                          ? 'mfa-action-code-api-error'
                          : requestMessageKey
                            ? 'mfa-action-request-message'
                            : null
                    " />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
            @if (codeForm.controls.code.invalid && codeForm.controls.code.touched) {
              <mat-error id="mfa-action-code-error">
                {{ 'MFA_ACTION_VERIFICATION_MODAL.ERRORS.CODE_REQUIRED' | translate }}
              </mat-error>
            }
            @if (codeErrorMessageKey) {
              <mat-error id="mfa-action-code-api-error" [innerHTML]="codeErrorMessageKey | translate"></mat-error>
            }
            @if (requestMessageKey) {
              <div
                id="mfa-action-request-message"
                class="request-message"
                [class.request-message--error]="requestMessageTone === 'error'"
                [class.request-message--success]="requestMessageTone === 'success'"
                [innerHTML]="requestMessageKey | translate"></div>
            }
          </form>
          <div class="resend-row">
            @if (resendCooldownSeconds > 0) {
              <span class="resend-timer" aria-live="polite">
                {{
                  'MFA_ACTION_VERIFICATION_MODAL.MESSAGES.RESEND_AVAILABLE_IN'
                    | translate: { seconds: resendCooldownSeconds }
                }}
              </span>
            }
            @if (resendCooldownSeconds === 0) {
              <button type="button" class="resend-button" (click)="resendCode()" [disabled]="loading">
                {{ 'MFA_ACTION_VERIFICATION_MODAL.ACTIONS.SEND_AGAIN' | translate }}
              </button>
            }
          </div>
        </div>
      }
      @if (loading) {
        <div class="spinner spinner--fullscreen" role="status" aria-live="polite">
          <span class="sr-only">{{ 'COMMON.LAYOUT.LOADING' | translate }}</span>
          <mat-spinner [diameter]="56" [attr.aria-hidden]="true"></mat-spinner>
        </div>
      }
    </div>
  }
  @if (currentStep === 'RESULT') {
    <div class="content result-content">
      <div class="result-card result-card--success">
        <mat-icon class="result-icon" aria-hidden="true">verified_user</mat-icon>
        <p
          id="mfa-action-result-description"
          class="text result-text"
          [innerHTML]="resultDescriptionKey | translate"></p>
      </div>
    </div>
  }

  <div class="action-buttons">
    @if (currentStep !== 'RESULT') {
      <button type="button" mat-raised-button (click)="close()" [disabled]="loading">
        {{ 'COMMON.ACTION.CANCEL' | translate }}
      </button>
    }
    @if (currentStep === 'RESULT') {
      <button type="button" mat-raised-button color="primary" (click)="close()">
        {{ 'COMMON.ACTION.CLOSE' | translate }}
      </button>
    }
    @if (currentStep !== 'RESULT') {
      <button type="button" mat-raised-button color="primary" (click)="confirm()" [disabled]="loading">
        {{ 'COMMON.ACTION.CONFIRM' | translate }}
      </button>
    }
  </div>
</div>
